import { InfoSnackbar } from '../../InfoSnackbar/InfoSnackbar';
import { resetMakedProfit } from "../../../redux/user";
import { useDispatch, useSelector } from "../../../hooks";
import currencySmallIcon from "../../../icons/currency-small.png";
import styles from "./MakedProfitNotify.module.scss";
import { formatNumberWithSpaces } from '../../../utils/numbers';

const DISPLAY_MAKED_PROFIT_RATE = 0.05;

export const MakedProfitNotify = () => {
    const dispatch = useDispatch();

    const { makedProfit, profit } = useSelector(store => store.user.info);

    const getMakedProfitMessage = () => {
        return (
            <>
                {'Доход: '}
                <img src={currencySmallIcon} className={styles.currencyIcon} alt="profit currency" />
                { `${formatNumberWithSpaces(makedProfit)} (бизнес)` }
            </>
        );
    }

    const getMakedProfitRate = () => makedProfit / profit;

    return (
        <>
            { getMakedProfitRate() > DISPLAY_MAKED_PROFIT_RATE
            && <InfoSnackbar infoMessage={ getMakedProfitMessage() } onCloseHandler={() => dispatch(resetMakedProfit()) } /> }
        </>
    );
}
